import { Checkbox, Drawer, Flex, Link, Text } from '@servicetitan/anvil2';
import { useEffect, useState } from 'react';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import { DisclosureDataStore } from './DisclosureStore';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

export const WellsFargoDisclosure = () => {
    const [showTerms, setShowTerms] = useState(false);
    const { setAgreedToDisclosures } = DisclosureDataStore.useStore();
    const { prequalAcknowledgementText, turnsCoapplicationDisclosureText } = useProviderConfig();

    // The checkbox is uncontrolled and starts unchecked on every mount.
    // Sync the store to match, so stale `true` from a previous submission
    // doesn't leave the submit button enabled while the checkbox is unchecked.
    useEffect(() => {
        setAgreedToDisclosures(false);
    }, [setAgreedToDisclosures]);

    return (
        <Flex direction="column" gap="4">
            <Flex direction="row" gap="2">
                <Checkbox
                    aria-label="I agree to Wells Fargo prequalification and Turns financing terms"
                    onChange={(e, state) => setAgreedToDisclosures(state?.checked ?? false)}
                />
                <Flex direction="column" gap="2">
                    <Text>{prequalAcknowledgementText}</Text>
                    <Text>
                        {turnsCoapplicationDisclosureText}{' '}
                        <Link onClick={() => setShowTerms(true)}>View terms</Link>
                    </Text>
                </Flex>
            </Flex>
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>Turns Financing Terms</Drawer.Header>
                    <Drawer.Content>
                        <TurnsDisclosureText />
                    </Drawer.Content>
                </Drawer>
            )}
        </Flex>
    );
};
